<template>

  <div class="home" :style="mobileBodyHeight"> 
    <Loading :active="loading"
      :can-cancel="true"
      :loader="'dots'"
      :color="'#00872D'"
      :height="130"
      :width="130"
      :opacity="0.3"
      :is-full-page="true" 
      > </Loading>
    <Header></Header>
    <div class="home-component">
    <component
        v-for="(component,i) in componentData"
        :key="i"
        :is="component.name"
        :data="component.data"
      />
    </div>
    <Footer></Footer> 
    <div v-html="tagImage" />
  </div>
</template>
<script>
// @ is an alias to /src
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import Iframe from '@/components/Iframe.vue'
import CarouselHeroBanner from '@/components/carousel/hero-banner.vue'
import CarouselONPackages from '@/components/carousel/product-packages.vue'
import CarouselGroupedONPackages from '@/components/carousel/group-product-packages.vue'

import TextIntro from '@/components/cards/text-intro.vue'
import TextColumns from '@/components/cards/text-column.vue'
import CarouselPromotionsBanner from '@/components/carousel/promotions-slim.vue'
import TitleComponent from '@/components/Title.vue'
import Loading from 'vue-loading-overlay';
import { mapGetters, mapState, useStore } from 'vuex'
import { watch, computed, ref } from 'vue'
import 'vue-loading-overlay/dist/vue-loading.css';
import { landingAlambrico } from '@/pixel/pixel.js'
import { useRoute, useRouter } from 'vue-router'
export default {
  name: 'Home',
  components: {
    Loading,
    Header,
    Footer,
    Iframe,
    CarouselHeroBanner,
    CarouselONPackages,
    CarouselGroupedONPackages,
    CarouselPromotionsBanner,
    TitleComponent,
    TextIntro,
    TextColumns,
  },
  computed:{
    ...mapGetters({
      componentData: 'getComponentData',
      mobileBodyHeight: 'GET_MOBILE_BODY_HEIGHT'
    }),
    ...mapState({
      loading: state => state.Home.loading ,
    }),
  },
  setup() {
      const store = useStore()
      const route = useRoute()
      const router = useRouter()
      const pageNumber = computed(() => {
        return  store.state.Home.pageNumber  
      })
      const tagImage = ref('')

      const setLandingPixel = () =>{
        landingAlambrico.tag()
        landingAlambrico.floodlight()
        tagImage.value =  landingAlambrico.image
      }
      watch(pageNumber, (val ) => {
        const pageNumber = { value : val }
       
        store.dispatch( 'callHomeData', pageNumber  )
      }) 
      
       if( pageNumber.value == '35' ){
        setLandingPixel()
      }

      const callData = () => {
        store.dispatch( 'callNavbarData' )
        store.dispatch( 'callFooterData' )
        store.dispatch( 'callHomeData', pageNumber )
      }

      const getSlug = async () => {
        if( route.params.pathMatch ){
          const slug =  route.params.pathMatch[0]
          const exist = await store.dispatch('callAllPages', slug)
          if ( exist ) {
              callData()
          } else {
            router.push( {name: "PageNotFound"} )
          }
        } else {
          callData()
        }
      }
   
     getSlug()

      return { tagImage }
  }
}
</script>
<style scoped>
.home-component{
  min-height: 80vh;
}


</style>
